import { createInstance, setLogger } from '@optimizely/react-sdk';

const createSdkInstance = ({ disableLogger, ...rest }) => {
    disableLogger && setLogger(null);
    return createInstance({ ...rest });
};

export default createSdkInstance;
